import React from 'react';
import { useTranslation } from 'react-i18next';

import { ExtraStyleType } from 'components/Common/Formik/FieldCustom/FieldCustom';
import RadioFieldCustom, {
  OptionType,
} from 'components/Common/Formik/RadioFieldCustom/RadioFieldCustom';
import TextFieldCustom from 'components/Common/Formik/TextFieldCustom/TextFieldCustom';
import { customerFields, customerDetailsFields } from 'model/ContactFormFields';

import styles from '../ContactPage.module.scss';

function ContactPersonalDetails({
  extraStyle,
}: {
  extraStyle: ExtraStyleType;
}): JSX.Element {
  const { t } = useTranslation(['contactPage', 'translation']);

  return (
    <>
      <h2>{t('LABEL_PERSONAL_DETAILS')}</h2>
      {customerFields.map(field => {
        const {
          disabled,
          name,
          label,
          required,
          validation,
          maxLength,
          type,
          options,
          autoComplete,
        } = field;
        if (type === 'radio') {
          return (
            <RadioFieldCustom
              key={name}
              label={label}
              name={name}
              options={options as OptionType[]}
              required={required}
              disabled={disabled}
              extraStyle={extraStyle}
              autoComplete={autoComplete as string}
              {...(validation && { validation: validation })}
              {...(maxLength && { maxLength: maxLength })}
            />
          );
        }

        return (
          <TextFieldCustom
            key={name}
            label={label}
            name={name}
            required={required}
            disabled={disabled}
            extraStyle={extraStyle}
            autoComplete={autoComplete as string}
            {...(validation && { validation: validation })}
            {...(maxLength && { maxLength: maxLength })}
          />
        );
      })}
      <p>{t('LABEL_CUSTOMER_DETAILS')}</p>
      {customerDetailsFields.map(field => {
        const { name, label } = field;
        return (
          <div className={styles.field} key={name}>
            <TextFieldCustom
              label={label as string}
              name={name}
              extraStyle={extraStyle}
            />
          </div>
        );
      })}
    </>
  );
}

export default ContactPersonalDetails;
